// extracted by mini-css-extract-plugin
export default {"card":"simpleCard_card__46uDG","title":"simpleCard_title__XH9jr","description":"simpleCard_description__fDnv+"};